import CurrencyToggle from './CurrencyToggle';

export default CurrencyToggle;
